import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";

const LEGAL_LINKS = [
  { to: "/contact", label: "Contact Us" },
  { to: "/refund-policy", label: "Refund & Cancellation" },
  { to: "/terms", label: "Terms & Conditions" },
];

export default function LegalLayout({ title, updated, testId, children }) {
  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 py-12">
        <div data-testid={testId} className="card-brutal p-8 md:p-10">
          <span className="label-mono">Legal</span>
          <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tighter mt-2">{title}</h1>
          {updated && <p className="text-sm text-[#52525B] mt-2">Last updated: {updated}</p>}
          <div className="mt-8 space-y-5 text-sm leading-relaxed [&_h2]:font-display [&_h2]:text-lg [&_h2]:font-bold [&_h2]:tracking-tight [&_h2]:mt-8 [&_h2]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_a]:text-blue-600 [&_a]:underline [&_a]:underline-offset-2">
            {children}
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm">
          {LEGAL_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="text-[#52525B] hover:text-[#0A0A0A] hover:underline underline-offset-4">
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
